import React, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';
import ProfileIcon from '../../../../common/icons/profileIcon';
import { useSelector, useDispatch } from 'react-redux';
import { updateProfile } from '../../../../../redux/actions/ProfileActions';
import { errorMessage } from '../../../../../redux/actions/FlashActions';
import { stateParser } from '../../../../../helpers/ProfileHelper';
import { schema } from './validation/schema';
import FormContainer from '../common/FormContainer';
import Title from '../common/Title';
import Buttons from '../common/Buttons';
import Form from './Form';
import { makeInitialState } from './InitialState';

const reducer = (state, { field, value }) => {
  if (field === 'reset') {
    return value;
  }
  return {
    ...state,
    [field]: value,
  };
};

const definePhoneNumber = (profile) => {
  const { phone1, mobilePhone1 } = profile;
  if (phone1) return phone1;
  if (mobilePhone1) return `9${mobilePhone1}`;
  return '';
};

const PersonalDataForm = ({ ...props }) => {
  const { mobile } = props;
  const reduxDispatch = useDispatch();
  const loading = useSelector((state) => state.profileReducer.loading);
  const error = useSelector((state) => state.profileReducer.error);
  const profile = useSelector((state) => state.profileReducer.profile);
  const [formState, setFormState] = useState('');
  const [state, dispatch] = useReducer(
    reducer,
    makeInitialState(
      profile.firstName,
      profile.lastName,
      profile.logonId,
      profile.dateOfBirth,
      definePhoneNumber(profile),
      profile.email1,
    ),
  );

  const cleanInputs = () => {
    for (let key in state) {
      dispatch({
        field: key,
        value: {
          value: state[key].value,
          error: false,
          helper: state[key].helper,
          inputAdornment: state[key].inputAdornment,
          label: state[key].label,
          success: false,
        },
      });
    }
  };

  const cleanInCancel = () => {
    const initialState = makeInitialState(
      profile.firstName,
      profile.lastName,
      profile.logonId,
      profile.dateOfBirth,
      definePhoneNumber(profile),
      profile.email1,
    );
    for (let key in initialState) {
      dispatch({
        field: key,
        value: {
          value: initialState[key].value,
          error: false,
          helper: initialState[key].helper,
          inputAdornment: initialState[key].inputAdornment,
          label: initialState[key].label,
          success: false,
        },
      });
    }
  };

  const handleSendClick = async () => {
    if ('error' in schema.validate(formState)) {
      reduxDispatch(
        errorMessage(
          'Debes completar todos los campos antes de enviar el formulario',
        ),
      );
    } else {
      await reduxDispatch(updateProfile(profile.userId, formState));
      cleanInputs();
    }
  };

  const handleFocus = (formState) => {
    setFormState(stateParser(formState));
  };

  return (
    <React.Fragment>
      <ProfileTitle
        mobile={mobile}
        title={<strong>Perfil</strong>}
        subtitle={'Aquí encontrarás tus datos personales'}
        icon={<ProfileIcon size="30px" color="#6A148E" />}
      />
      <FormContainer>
        <Title shouldModify={true} title="Mis Datos Personales"></Title>
        <Form dispatch={dispatch} state={state} onFocus={handleFocus} />
        <Buttons
          loading={loading}
          error={error}
          onCancelClick={cleanInCancel}
          onSendClick={handleSendClick}
          mobile={mobile}
        />
      </FormContainer>
    </React.Fragment>
  );
};

PersonalDataForm.propTypes = {
  mobile: PropTypes.bool,
};

export default PersonalDataForm;
